import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { validateEmail } from 'utils/validators';
import {
  sendConsumerMagicLink,
  getTenantContext,
} from 'services/b2c/consumerAuthService';

const ConsumerLogin = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus('');

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setSubmitting(true);

    try {
      const tenantContext = getTenantContext();
      const resp = await sendConsumerMagicLink(email.trim(), {
        organizationId: tenantContext.organizationId,
        branchId: tenantContext.branchId,
        loanOfficerId: tenantContext.loanOfficerId,
        organizationSlug: tenantContext.slug,
        branchSlug: tenantContext.branchSlug,
      });
      const data = resp?.data ?? {};
      sessionStorage.setItem('mira_awaiting_magic_link', 'true');
      if (data.needs_onboarding) {
        setStatus(
          data.message ||
            "We've sent your registration link. Please check your email to complete your account setup."
        );
      } else {
        setStatus(
          data.message || 'Magic link sent! Please check your email to continue.'
        );
      }
    } catch (submitError) {
      const statusCode = submitError?.response?.status;
      const apiDetail = submitError?.response?.data?.detail;

      if (statusCode === 403) {
        setError(apiDetail || 'Access denied. Please contact your loan officer.');
      } else if (statusCode === 404) {
        setError(apiDetail || 'User not found. Please contact your loan officer.');
      } else {
        setError(
          apiDetail ||
            submitError?.message ||
            'Unable to send magic link. Please try again.'
        );
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full">
      <form onSubmit={handleSubmit} className="w-full flex flex-col gap-4">
        <div>
          <label htmlFor="consumer-email" className="block text-sm font-medium text-gray-600 mb-1.5">
            Email Address
          </label>
          <input
            id="consumer-email"
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError('');
              setStatus('');
            }}
            placeholder="Enter your email"
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-sm"
          />
        </div>

        {error && (
          <div className="p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">
            {error}
          </div>
        )}

        {status && (
          <div className="p-3 bg-green-50 border border-green-200 text-green-700 rounded-lg text-sm">
            {status}
          </div>
        )}

        <button
          type="submit"
          disabled={submitting || !email}
          className="w-full flex items-center justify-center gap-2 btn-primary py-3 px-4 rounded-lg text-white font-semibold text-sm disabled:opacity-60 transition-all"
        >
          {submitting ? 'Sending magic link...' : 'Send Magic Link'}
          <ArrowRight size={16} strokeWidth={2.5} />
        </button>
      </form>
    </div>
  );
};

export default ConsumerLogin;
